import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import ReceiptTableRow from "./ReceiptTableRow";
import jMoment from "moment-jalaali";

const ReceiptTable = (props) => {
	const handleChange = (event, value) => {
		props.getPage(value);
	};
	return (
		<>
			<TableContainer component={Paper} aria-label="simple table">
				<Table>
					<TableHead>
						<TableRow>
							<TableCell />
							<TableCell align="justify">شماره فاکتور</TableCell>
							<TableCell align="justify">تاریخ صدور</TableCell>
							<TableCell align="justify">نام پزشک</TableCell>
							<TableCell align="justify">به نام</TableCell>
							<TableCell align="justify">تعداد کار</TableCell>
							<TableCell align="justify">قیمت مجموع</TableCell>
							<TableCell align="justify">وضعیت پرداخت</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.data &&
							props.data.map((receipt) => {
								return (
									<ReceiptTableRow
										key={receipt.id}
										receiptId={receipt.id}
										receiptCode={receipt.receiptCode}
										submissionDate={jMoment(
											parseInt(receipt.submissionDate)
										).format("jYY/jMM/jDD")}
										doctorName={receipt.doctor.name}
										name={receipt.name}
										orderCount={receipt.receipts.length}
										totalPrice={receipt.receiptTotal}
										isPaid={receipt.isPayed}
									/>
								);
							})}
					</TableBody>
				</Table>
			</TableContainer>
			{props.pageCount > 1 && (
				<Pagination
					sx={{ mt: 4, justifyContent: "center", display: "flex" }}
					count={props.pageCount}
					onChange={handleChange}
				/>
			)}
		</>
	);
};

export default ReceiptTable;
